import type { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';

import {
  GetShoppingSummaryItineraryQuery,
  GetShoppingSummaryItineraryQueryVariables,
  FeeSelected,
} from 'generated/graphql';
import { SHOPPING_SUMMARY_ITINERARY } from 'clientState/providers/operations/shoppingSummaryItinerary';

export interface ShoppingSummaryItineraryData {
  products: GetShoppingSummaryItineraryQuery['getShoppingSummary']['products'];
}

export interface UseShoppingSummaryItineraryQuery {
  errors: UseQueryResult<
    GetShoppingSummaryItineraryQuery,
    GetShoppingSummaryItineraryQueryVariables
  >['errors'];
  loading: UseQueryResult<
    GetShoppingSummaryItineraryQuery,
    GetShoppingSummaryItineraryQueryVariables
  >['loading'];
  data: ShoppingSummaryItineraryData | undefined;
}

export const useShoppingSummaryItinerary = (
  flightSelectionData
): UseShoppingSummaryItineraryQuery => {
  const {
    fareItineraryKey = '',
    priceWithoutDiscountSelected,
    searchId = '',
    segmentKeys = [],
  } = flightSelectionData?.data || {};
  const feeSelected = priceWithoutDiscountSelected
    ? FeeSelected.FullPrice
    : FeeSelected.PrimePrice;
  const isMeta = false;
  const result = useQuery<
    GetShoppingSummaryItineraryQuery,
    GetShoppingSummaryItineraryQueryVariables
  >(SHOPPING_SUMMARY_ITINERARY, {
    variables: {
      request: {
        fareItineraryKey: fareItineraryKey.split('_')[0],
        feeSelected,
        isMeta,
        searchId: String(searchId),
        segmentKeys,
      },
    },
    skip: !fareItineraryKey || !searchId,
  });
  useLogFrontendApiError(result);
  const { data, ...rest } = result;

  return {
    data: {
      products: data?.getShoppingSummary.products || [],
    },
    ...rest,
  };
};
